export default "__VITE_ASSET__CnlKjxf$__"